import classNames from 'classnames';
import { SwiperSlide } from 'swiper/react';
import { Heading } from 'yoso';
import { breakpoints, useIsSmallerThan } from '~/components/Breakpoint/Breakpoint.hook';
import { Carousel, CarouselProps } from '~/components/Carousel/Carousel';
import { T } from '~/components/I18n';
import { useStoreNfts } from '~/components/Nft';
import { StoreNftCard } from '~/components/Nft/Store/Card/StoreNftCard';
import styles from './HomeDropShop.module.scss';

export type HomeDropShopProps = { className?: string };

const carouselProps: CarouselProps = {
  className: styles.carousel,
  navigation: true,
  pagination: true,
  shadow: true,
  centerInsufficientSlides: true,
  breakpoints: {
    0: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
    [breakpoints.small]: {
      slidesPerView: 1.5,
      spaceBetween: 10,
    },
    [breakpoints.medium]: {
      slidesPerView: 3,
      spaceBetween: 10,
    },
    [breakpoints.large]: {
      slidesPerView: 1,
      spaceBetween: 80,
    },
  },
};
export const HomeDropShop = ({ className }: HomeDropShopProps) => {
  const { data } = useStoreNfts(
    { size: 20 },
    {
      select: (data) => data.filter((d) => d.saleStatus !== 'CLOSED'),
    }
  );
  const isLarge = !useIsSmallerThan(breakpoints.large);
  const direction = isLarge ? 'row' : 'column';

  return (
    <div className={classNames(styles.root, className)}>
      <div className={styles.header}>
        <Heading className={styles.heading}>
          <T name="citizen_home_b2c_title" />
        </Heading>
      </div>
      <div className={styles.body}>
        <Carousel {...carouselProps}>
          {data.map((nft) => (
            <SwiperSlide key={nft.saleId} className={styles.slide}>
              <a
                href={`${import.meta.env.VITE_CITIZEN_STORE_URL}/1st_sale/sales/${nft.saleId}`}
                className={classNames('display-block', styles.link)}
                data-event="click"
                data-event-target="b2c_sale_in_citizen_home"
                data-event-brand_id={nft.brandId}
                data-event-product_id={nft.saleId}
                data-event-currency_type={nft.currency}
                data-event-sale_price={nft.price}
                data-event-sale_status={nft.saleStatus}>
                <StoreNftCard {...nft} direction={direction} size="large" shadow={false} />
              </a>
            </SwiperSlide>
          ))}
        </Carousel>
      </div>
    </div>
  );
};
